<template>
  <div class="md-layout">
    <draggable
      v-model="listQuestion"
      class="md-layout-item md-size-100 md-layout"
    >
      <transition-group class="md-layout-item md-size-100 md-layout">
        <div
          v-for="(question, index) in listQuestion"
          :key="index + 'question'"
          class="md-layout-item md-size-100 md-layout cursor-move"
        >
          <div
            v-if="!isReadOnly"
            class="md-layout-item md-size-10 flex flex-col justify-center gap-4"
          >
            <div
              v-if="index !== 0"
              class="flex cursor-pointer"
              @click="indexDown(question, index)"
            >
              <md-icon class="text-[48px] up-down-arrow">arrow_drop_up</md-icon>
            </div>
            <div
              v-if="index < listQuestion.length - 1"
              class="flex cursor-pointer"
              @click="indexUp(question, index)"
            >
              <md-icon class="text-[48px] up-down-arrow"
                >arrow_drop_down
              </md-icon>
            </div>
          </div>
          <div
            :class="{ 'md-size-100': isReadOnly }"
            class="md-layout-item md-size-80 border border-gray-300 mb-4"
          >
            <div
              :class="{ 'not-allowed': isReadOnly }"
              class="question-text flex"
            >
              <span :class="{ 'mark-required': question.require }" class="mr-2"
                >{{ index + 1 }}.</span
              >
              <div v-html="question.question"></div>
            </div>
            <div
              :class="{ 'not-allowed': isReadOnly }"
              class="question-subtext"
            >
              {{ question.subText }}
            </div>
            <div v-if="question.type === type.dropdown">
              <md-field>
                <md-select>
                  <md-option
                    v-for="(choice, index) in question.choices"
                    :key="index + 'dropdown'"
                    :value="choice.text"
                  >
                    {{ choice.text }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div v-if="question.type === type.radio">
              <div
                v-for="(choice, index) in question.choices"
                :key="index + 'radio'"
              >
                <md-radio v-model="question.defaultValue" :value="choice.text"
                  >{{ choice.text }}
                </md-radio>
              </div>
            </div>
            <div v-if="question.type === type.checkbox">
              <div
                v-for="(choice, index) in question.choices"
                :key="index + 'checkbox'"
              >
                <md-checkbox
                  v-model="question.defaultValue"
                  :value="choice.text"
                  >{{ choice.text }}
                </md-checkbox>
              </div>
            </div>
            <div v-if="question.type === type.singleLineText">
              <validation-field
                v-if="question.number_only"
                :validations="{ format: formatValidation }"
                name="question"
              >
                <md-input
                  v-model="question.defaultValue"
                  :disabled="isReadOnly"
                ></md-input>
              </validation-field>
              <md-field v-else>
                <md-input :disabled="isReadOnly"></md-input>
              </md-field>
            </div>
            <div v-if="question.type === type.multiLineText">
              <md-field>
                <md-textarea
                  :class="{ 'not-allowed': isReadOnly }"
                  :disabled="isReadOnly"
                ></md-textarea>
              </md-field>
            </div>
          </div>
          <div
            v-if="!isReadOnly"
            class="md-layout-item md-size-10 flex flex-col justify-center gap-4"
          >
            <div
              class="flex cursor-pointer"
              @click="showModal(question.type, 'edit', question, index)"
            >
              <md-icon class="text-green">edit</md-icon>
            </div>
            <div class="flex cursor-pointer" @click="removeQuestion(index)">
              <md-icon class="text-red">delete</md-icon>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div
      :class="{ 'not-allowed': isReadOnly }"
      class="md-layout-item md-size-100 flex justify-center gap-4 mt-5"
    >
      <md-button
        :disabled="isReadOnly"
        class="md-success rounded-none"
        @click="showModal(type.dropdown, 'add')"
        >{{ $t("survey.add_drop_down") }}
      </md-button>
      <md-button
        :disabled="isReadOnly"
        class="md-success rounded-none"
        @click="showModal(type.radio, 'add')"
        >{{ $t("survey.add_radio_button") }}
      </md-button>
      <md-button
        :disabled="isReadOnly"
        class="md-success rounded-none"
        @click="showModal(type.checkbox, 'add')"
        >{{ $t("survey.add_checkbox") }}
      </md-button>
      <md-button
        :disabled="isReadOnly"
        class="md-success rounded-none"
        @click="showModal(type.singleLineText, 'add')"
        >{{ $t("survey.add_single_text") }}
      </md-button>
      <md-button
        :disabled="isReadOnly"
        class="md-success rounded-none"
        @click="showModal(type.multiLineText, 'add')"
        >{{ $t("survey.add_multi_text") }}
      </md-button>
    </div>
    <div class="md-layout-item md-size-100 flex justify-center gap-4 mt-5">
      <md-button class="md-primary h-[40px] text-3xl" @click="backToGerneral">
        &lt;
      </md-button>
      <md-button class="md-primary h-[40px] text-3xl" @click="goToEmail">
        &gt;
      </md-button>
    </div>
    <common-modal
      :hideFooter="true"
      :name="modal.name"
      :title="modal.title"
      height="auto"
      width="80%"
    >
      <template #modal-body>
        <AddQuestionModal
          :data="selectedQuestion"
          :modalName="modal.name"
          :modalType="modal.type"
          :mode="modalMode"
          @addQuestion="addQuestion"
          @editQuestion="editQuestion"
        >
        </AddQuestionModal>
      </template>
    </common-modal>
  </div>
</template>
<script>
import CommonModal from "@/components/Base/CommonModal";
import { Message } from "@/helpers/utils";
import AddQuestionModal from "./AddQuestionModal";
import draggable from "vuedraggable";

export default {
  props: ["data", "isReadOnly"],
  components: { CommonModal, AddQuestionModal, draggable },
  data() {
    const type = {
      dropdown: "drop_down_list",
      radio: "radio_button",
      checkbox: "checkbox",
      singleLineText: "single_line_text",
      multiLineText: "multi_line_text"
    };
    let modalType = {
      drop_down_list: {
        type: type.dropdown,
        title: "survey.dropdown",
        name: "dropdown-question"
      },
      radio_button: {
        type: type.radio,
        title: "survey.radio",
        name: "radio-question"
      },
      checkbox: {
        type: type.checkbox,
        title: "survey.checkbox",
        name: "checkbox-question"
      },
      single_line_text: {
        type: type.singleLineText,
        title: "survey.single_line_text",
        name: "single-line-text-question"
      },
      multi_line_text: {
        type: type.multiLineText,
        title: "survey.multi_line_text",
        name: "multi-line-text-question"
      }
    };
    return {
      type,
      modalType,
      modal: {},
      listQuestion: [],
      modalMode: "add",
      selectedQuestion: {},
      selectedIndex: null,
      formatValidation: {
        valid: value => /^\d+$/.test(value.trim()),
        message: this.$t("validation.format", { fieldName: "value" })
      }
    };
  },
  created() {
    if (this.data.length) {
      this.listQuestion = this.data;
    }
    if (this.data.questions) {
      this.listQuestion = this.data.questions;
    }
  },
  methods: {
    indexUp(question, index) {
      this.listQuestion.splice(index, 1);
      this.listQuestion.splice(index + 1, 0, question);
    },
    indexDown(question, index) {
      this.listQuestion.splice(index, 1);
      this.listQuestion.splice(index - 1, 0, question);
    },
    backToGerneral() {
      this.$emit("backToGerneral", this.listQuestion);
    },
    goToEmail() {
      if (this.listQuestion.length) {
        this.$emit("goToEmail", this.listQuestion);
      } else {
        Message.error(this.$t("survey.least_question"));
      }
    },
    showModal(type, mode, question, index) {
      this.modal = this.modalType[type];
      this.modalMode = mode;
      this.selectedIndex = index;
      this.selectedQuestion = question;
      this.$nextTick(() => {
        this.$modal.show(this.modal.name);
      });
    },
    addQuestion(question) {
      this.listQuestion.push(question);
    },
    editQuestion(question) {
      this.listQuestion.splice(this.selectedIndex, 1, question);
    },
    removeQuestion(index) {
      this.listQuestion.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-red {
  color: red !important;
}

.text-green {
  color: green !important;
}

.question-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.1px;
  color: #242424;
}

.question-subtext {
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.1px;
  color: #242424;
}

.md-button.md-success:disabled {
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 0.7;
  cursor: not-allowed;
}

.not-allowed {
  cursor: not-allowed;
}

.md-field.md-has-textarea:not(.md-autogrow).md-has-value .md-textarea {
  padding-top: 20px;
  cursor: not-allowed;
}

.up-down-arrow {
  opacity: 0.8;
  border-radius: 100%;
  background-color: #ccc;

  &:hover {
    opacity: 1;
  }
}

.mark-required::after {
  content: "*";
  color: red;
}
</style>
